import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    authenticationHistoryData: [],
    selectedHistoryDetails: null,
    pagination: null,
    loading: false,
    error: null,
};

export const getAllAuthenticationHistory = createAsyncThunk(
    "authentication-history/get-all-history",
    async ({ user, pagination, orderBy, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            const { sortColumn, isAsce } = orderBy;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.searchauthenticationhistory;

            const apiURL = base + endpointpath + `${pageSize}/${currentPage}/${sortColumn}/${isAsce}`;

            const response = await axiosInstance.post(apiURL, search);

            if(response?.data?.responseCode === '404') {
                toast.error(response?.data?.responseDescription);
            }

            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const getAuthenticationHistoryByID = createAsyncThunk(
    "authentication-history/get-history-by-id",
    async ({ user, id }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getSpecificAuthenticationHistory;

            const apiURL = base + endpointpath + id;

            const response = await axiosInstance.get(apiURL);

            if(response?.data?.responseCode === '404') {
                toast.error(response?.data?.responseDescription);
            }

            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const authenticationHistorySlice = createSlice({
    name: "authentication-history",
    initialState,
    reducers: {
        resetSelected: (state) => {
            state.selectedHistoryDetails = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // GET ALL AUTHENTICATION HISTORY
            .addCase(getAllAuthenticationHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllAuthenticationHistory.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.authenticationHistoryData = data || [];
                state.pagination = {
                    currentPage: currentPage || 0,
                    pageSize: pageSize || 20,
                    totalItem,
                    totalPages
                };
            })
            .addCase(getAllAuthenticationHistory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // GET ALL AUTHENTICATION HISTORY
            .addCase(getAuthenticationHistoryByID.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAuthenticationHistoryByID.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedHistoryDetails = action?.payload?.data;
            })
            .addCase(getAuthenticationHistoryByID.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export const { resetSelected } = authenticationHistorySlice.actions;

export default authenticationHistorySlice.reducer;